var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD1E3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72CAE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ED3E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82CFE2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD1E3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CBE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80CEE2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CBE1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4DCFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549AC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD1F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87C4E9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4DCFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#589DC5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFE4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62A5CD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-2h57v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 2H2v12h13V9.9a4.977 4.977 0 0 0 2-.9v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10a5.018 5.018 0 0 0-1.584 2z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.201 5.495c.385.63 1.526 1.091 1.798 1.046A2 2 0 1 1 6.127 3.3c-.174.213-.31 1.567.074 2.195z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M14 3V0h2v3h3v2h-3v3h-2V5h-3V3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M7.067 11.133L10 6l4 7H3l2.5-5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.416 2H2v12h13V9.9a4.977 4.977 0 0 0 2-.9v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10a5.018 5.018 0 0 0-1.584 2z",
    fill: "url(#e)",
    transform: "translate(20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 5.5c.385.629 1.526 1.09 1.798 1.046a2 2 0 1 1-1.872-3.241c-.174.213-.31 1.566.074 2.195z",
    fill: "url(#f)",
    transform: "translate(20)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M14 3V0h2v3h3v2h-3v3h-2V5h-3V3z",
    transform: "translate(20)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M7.067 11.133L10 6l4 7H3l2.5-5z",
    transform: "translate(20)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2 4.5c.385.629 1.526 1.09 1.798 1.046a2 2 0 1 1-1.872-3.241c-.174.213-.31 1.566.074 2.195z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M6.067 10.133L9 5l4 7H2l2.5-5z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#e)",
    strokeWidth: 2,
    width: 15,
    height: 14,
    rx: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.2c318bf209eb06698976375fc0295319.svg";
export { ForwardRef as ReactComponent };